// extracted by mini-css-extract-plugin
module.exports = {"legendContainer":"RadarLegend_legendContainer__HGgCi","legendButton":"RadarLegend_legendButton__AX9gS","legend":"RadarLegend_legend__kLoWm"};